import React, { Component } from 'react'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image, Button } from 'react-bootstrap'
import moment from 'moment';
import { withRouter, Link, matchPath } from 'react-router-dom'
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import { isBrowser, isMobile } from "react-device-detect";
import ChangePassword from './ChangePassword';
import Notification from './Notification';
import NetworkStatus from './NetworkStatus';
import ExamSwitcher from './ExamSwitcher';
import HEADER_COLORS from './headerColors';
import './_navbars.scss';
import './_commonheader.scss';

const USERLOGOUT = gql`
  mutation(
    $student_user_exam_id: Int,
    $device_id: String) {
    userLogout(student_user_exam_id: $student_user_exam_id,device_id: $device_id)
  }
`;

// Named colours a page can pass as `color`. "home" is the student home header.
const COLOR_PRESETS = {
    home: "linear-gradient(180deg, #5db8fd 0%, #116cd3 74%)",
};

// color="auto": every page gets a colour of its own, from the per-route table
// (unique for every route in App.js). A page missing from the table gets a
// colour computed from its address instead.
function autoColor(pathname) {
    const route = HEADER_COLORS.find(([path]) => matchPath(pathname || "", { path, exact: true }));
    if (route) return route[1];
    return hashedColor(pathname);
}

// Hue (0-359) from the address; yellow/green hues are darkened so the white
// text stays readable.
function hashedColor(pathname) {
    // Ignore ids so /student/doubts/12 and /student/doubts/34 share a colour.
    const key = String(pathname || "").replace(/\/\d+(?=\/|$)/g, "").toLowerCase();
    let hash = 2166136261;
    for (let i = 0; i < key.length; i++) {
        hash ^= key.charCodeAt(i);
        hash = Math.imul(hash, 16777619) >>> 0;
    }
    // Same muted style as headerColors.js, skipping neon pink/magenta.
    let hue = hash % 310;
    if (hue >= 285) hue += 50;
    const light = hue >= 40 && hue <= 170 ? 32 : 40;
    return `linear-gradient(180deg, hsl(${hue}, 55%, ${light + 14}%) 0%, hsl(${(hue + 12) % 360}, 60%, ${light}%) 74%)`;
}

function resolveColor(color, location) {
    if (!color) return null;
    if (color === "auto") return autoColor(location && location.pathname);
    return COLOR_PRESETS[color] || color;
}

// Access restrictions (ins_profile_tab, referred_mobile, ...) cached at login.
// A missing or malformed entry yields {} so the header still renders.
function readUserAccess() {
    try {
        const stored = JSON.parse(localStorage.getItem("isStudentUserValid"));
        if (!stored || !stored.user_access_restictions) return {};
        return JSON.parse(stored.user_access_restictions) || {};
    } catch (e) {
        return {};
    }
}

/**
 * The one page header used across the student module.
 *
 * Everything on the right (notifications, exam switcher, profile menu, change
 * password, logout) is identical on every page. A page only chooses:
 *
 *   color           background of the header: "auto" (a colour of its own for
 *                   each page), "home" (the student home blue) or any CSS
 *                   background. Omit it to keep whatever the page wrapper
 *                   paints behind the header.
 *   tone            "light" = white text (for dark/colourful backgrounds),
 *                   "dark"  = dark text (for white/pale backgrounds).
 *   onToggleSidebar shows the sidebar (hamburger) button when given.
 *   back            false | true (history back) | "/path" | { pathname, state }
 *   title           page title, large in the middle of the bar on desktop and
 *                   under the bar on mobile (mobileTitle={false} keeps it in
 *                   the bar).
 *
 * Logged-in pages also get the home greeting row (name, date) under the bar.
 *   left            extra content after the title (e.g. a brand logo).
 *   showUserMenu    false hides the whole right side (public pages).
 *   container       false makes the bar full width.
 */
class CommonHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            loader: 0
        }
        this.rootRef = React.createRef();
    }

    // Most pages pin the header (.header-area is position: fixed) and push
    // their content down by its height. That height varies with the greeting
    // row and screen width, so publish it for the CSS to use.
    publishHeight = () => {
        const el = this.rootRef.current;
        if (el) document.documentElement.style.setProperty("--common-header-height", el.offsetHeight + "px");
    };

    componentDidMount() {
        this.publishHeight();
        window.addEventListener("resize", this.publishHeight);
    }

    componentDidUpdate() {
        this.publishHeight();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.publishHeight);
    }

    logout = e => {
        e.preventDefault();
        this.setState({ loader: 1 });
        this.userLogout(parseInt(Cookies.get("student_user_exam_id")), "").catch(error => {
            this.setState({ loader: 0 });
            console.error("ERR =>", (error.graphQLErrors || []).map(x => x.message));
        });
    };

    userLogout = async (student_user_exam_id, device_id) => {
        await this.props.userLogout({
            variables: { student_user_exam_id, device_id },
            update: (store, { data }) => {
                if (data.userLogout) {
                    Cookies.remove("studenttoken");
                    Cookies.remove("studentrefreshtoken");
                    Cookies.remove("studentusername");
                    Cookies.remove("studentemail");
                    Cookies.remove("registermob");
                    Cookies.remove("classid");
                    Cookies.remove("examid");
                    Cookies.remove("exam_name");
                    Cookies.remove("mobileverified");
                    Cookies.remove("targetyear");
                    Cookies.remove("videos");
                    Cookies.remove("branch_name");
                    Cookies.remove("role", "");
                    Cookies.remove("profile_pic");
                    Cookies.remove("student_userlevel");
                    Cookies.remove("stulogintype", "");
                    localStorage.removeItem('profile_pic');
                    localStorage.removeItem('studentglobals');
                    localStorage.removeItem('globalsubjects');
                    localStorage.removeItem("packageplan");
                    Cookies.remove("toggle");
                    this.setState({ loader: 0 });
                    if (window.ReactNativeWebView) {
                        this.props.history.push("/student/logineamcet");
                        window.ReactNativeWebView.postMessage("LOGOUT");
                        return;
                    }
                    if (Cookies.get("institution_id") == 119) {
                        window.location.href = "https://vignan.rizee.in/login";
                    } else {
                        this.props.history.push("/student/login");
                    }
                }
            }
        });
    };

    renderBack() {
        const { back, backLabel = "Back", history } = this.props;
        if (!back) return null;

        const content = (
            <React.Fragment>
                <i className="fas fa-long-arrow-alt-left font-weight-bold" />
                <span className="font-weight-bold ml-2 d-none d-md-block">{backLabel}</span>
            </React.Fragment>
        );
        if (back === true) {
            return (
                <Button variant="link" className="common-header-back mr-2 d-flex align-items-center" onClick={history.goBack}>
                    {content}
                </Button>
            );
        }
        return (
            <Link className="common-header-back mr-2 d-flex align-items-center" to={back}>
                {content}
            </Link>
        );
    }

    renderProfile() {
        const profilePic = localStorage.getItem("profile_pic");
        const hasProfilePic = profilePic && profilePic !== "null" && profilePic !== "undefined";
        return (
            <div className="profile-img d-flex align-items-center">
                {hasProfilePic ? (
                    <Image
                        src={`https://support.rizee.in/files/${profilePic}`}
                        roundedCircle
                        alt="profile-img"
                        onError={(e) => { e.target.onerror = null; e.target.src = require('../../../images/businessman.png'); }}
                    />
                ) : (
                    <Image src={require('../../../images/businessman.png')} roundedCircle alt="profile-img" />
                )}
                <div className="text mx-2 mt-2">
                    <div className="profile-name">{Cookies.get("studentusername")}</div>
                    {this.state.loader == 0
                        ? <small>Exam - {Cookies.get("exam_name")}</small>
                        : <small>Logging Out...</small>}
                </div>
            </div>
        );
    }

    renderUserMenu(isuserValid) {
        const examId = Cookies.get("examid");
        return (
            <Nav className="ml-auto">
                <NetworkStatus />
                <Notification />
                <ExamSwitcher />
                <NavDropdown id="basic-nav-dropdown2" className="no-arrow" alignRight title={this.renderProfile()}>
                    <NavDropdown.Item className="font-weight-bold">{Cookies.get("studentemail")}</NavDropdown.Item>
                    <NavDropdown.Divider />
                    {isuserValid.ins_profile_tab == true ? null : (
                        <NavDropdown.Item as={Link} to="/student/profile"><i className="far fa-user mr-2" /> My Profile</NavDropdown.Item>
                    )}
                    {isuserValid.ins_package_tab == true ? null : (
                        <NavDropdown.Item as={Link} to={examId == 1 || examId == 2 ? "/student/package" : "/student/plans_section"}><i className="far fa-sack mr-2" /> Subscription Plans</NavDropdown.Item>
                    )}
                    <NavDropdown.Item onClick={() => this.setState({ modalShow: true })}><i className="far fa-key mr-2" /> Change Password</NavDropdown.Item>
                    {isuserValid.ins_feedback_tab == true ? null : (
                        <NavDropdown.Item as={Link} to="/student/feedback"><i className="far fa-comment-alt-lines mr-2" /> Feedback</NavDropdown.Item>
                    )}
                    <NavDropdown.Divider />
                    <NavDropdown.Item as={Link} to="#" onClick={this.logout}><i className="far fa-sign-out mr-2" /> Logout</NavDropdown.Item>
                </NavDropdown>
            </Nav>
        );
    }

    render() {
        const {
            color, tone, onToggleSidebar, title, left,
            showUserMenu = true, container = true, mobileTitle = true, className = ""
        } = this.props;
        const isuserValid = readUserAccess();
        // Referral partner "gsl635" accounts never get the user area.
        const userMenuVisible = showUserMenu && isuserValid.referred_mobile != "gsl635";

        const background = resolveColor(color, this.props.location);
        const Wrap = container ? Container : React.Fragment;
        const toneClass = (tone ? ` common-header--${tone}` : "") + (color ? " common-header--colored" : "");
        // The greeting row needs a logged-in student to greet.
        const greet = userMenuVisible && !!Cookies.get("studenttoken");

        // The student home header, on every page: the bar with the page title
        // large in the middle, and the greeting row underneath, all in one
        // coloured block. Only the colour differs between pages.
        return (
            <div ref={this.rootRef} className={`common-header${toneClass} ${className}`} style={background ? { background } : undefined}>
                <Navbar className="header-top">
                    <Wrap>
                        {onToggleSidebar ? (
                            <Button variant="light" className="px-2 py-1 mr-2" onClick={() => onToggleSidebar()}>
                                <i className="fal fa-bars" />
                            </Button>
                        ) : null}
                        {this.renderBack()}
                        {left}
                        {title && (isBrowser || !mobileTitle) ? <h3 className="exam_name_des common-header-title mx-auto mb-0">{title}</h3> : null}
                        {userMenuVisible ? this.renderUserMenu(isuserValid) : null}
                    </Wrap>
                    <ChangePassword
                        show={this.state.modalShow}
                        onHide={() => this.setState({ modalShow: false })}
                    />
                </Navbar>
                {title && isMobile && mobileTitle ? <h6 className="common-header-title common-header-title--mobile">{title}</h6> : null}
                {greet ? (
                    <Container className="header-bottom">
                        <Row className="align-items-end pt-xl-2 pt-lg-2 pb-4">
                            <Col xl={{ span: 4, order: 1 }} lg={{ span: 6, order: 1 }} md={6} sm={6} xs={12}>
                                <h6 className="common-header-greeting mb-1"><span className="font-weight-normal">Hey there!</span><br /> Greetings {Cookies.get("studentusername")},</h6>
                                <p className="common-header-greeting-sub mb-0">Start new goal and improve your result</p>
                            </Col>
                            <Col xl={{ span: 4, offset: 4, order: 2 }} lg={{ span: 6, order: 2 }} md={6} sm={6} xs={12} className="text-sm-right">
                                <p className="common-header-greeting-sub mb-0">{moment().format("DD-MM-YYYY @ LT")}</p>
                                <small className="common-header-greeting-hint">let's do some task today</small>
                            </Col>
                        </Row>
                    </Container>
                ) : null}
            </div>
        );
    }
}

export default withRouter(compose(
    graphql(USERLOGOUT, { name: "userLogout" })
)(CommonHeader));
